module.exports = __webpack_public_path__ + "img/reference-kaesstecherei.dd796dc5.webp";